module.exports = __webpack_public_path__ + "img/17.43333de6.png";